<div class="wrapper">
  <div class="row">
    <div class="col-sm-12 mb-2">
      <h1 class="pageTitle">{{ pageTitle }}</h1>
      <app-notifications [notification]="'booking_details_page_notification_banner_child'"></app-notifications>
      <hr />

      <!-- Summary of everything that needs fixing, linked to the field it
           belongs to. Focused after a failed submit so it is announced. -->
      <div class="error-summary" role="alert" tabindex="-1" #errorSummaryPanel aria-labelledby="error-summary-title"
        *ngIf="errorSummary.length > 0">
        <h2 class="error-summary__title" id="error-summary-title">
          There is a problem
        </h2>
        <div class="error-summary__body">
          <ul>
            <li *ngFor="let error of errorSummary">
              <a href="#" (click)="focusField(error.fieldId, $event)">{{ error.message }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt-4 mb-4 inform-box" *ngIf="this.showWasteWarning">
        <div class="col-sm-12">
          <div class="row important-heading">
            <h2 class="important-text important-box-heading">Important</h2>
          </div>
          <br />
          <div class="row important-box-contents">
            <p class="wasteDetails" *ngIf="wasteLimit.windowMaxDayLimit.limitBreached">
              <span [innerHTML]="parseWarning(this.datastoreService.config.diyWasteVisitLimitMessage)"></span>
            </p>
            <p *ngIf="wasteLimit.windowMaxWeightLimit.limitBreached" class="wasteDetails">
              <span [innerHTML]="parseWarning(this.datastoreService.config.diyWasteQuantityLimitMessage)"></span>
            </p>
            <button class="btn btn-primary float-right" style="width: 200px; margin-bottom: 20px;" type="button"
              title="Next" aria-label="Next to summary" [disabled]="subtmitButtonDisabled" (click)="completeDetails()">
              <span><span>{{ 'COMMON.CONTINUE' | translate }}</span>
                <fa-icon [icon]="faChevronRight"></fa-icon>
              </span>
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-7 col-lg-8 mt-4">
      <div class="card bb-panel">
        <form [formGroup]="customerDetailsForm" class="col-sm-12" [class.submitted]="submitted">
          <h2 class="mt-1 pb-4">Personal information</h2>
          <div>
            <div class="form-group">
              <label for="first_name">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span>
                {{ 'COMMON.FIRST_NAME' | translate }}</label>
              <input id="first_name" type="text" class="form-control" formControlName="first_name" role="textbox" />
              <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                <div *ngIf="form.first_name.errors.required" role="alert" tabindex="0">
                  First name is required
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="last_name">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span>
                {{ 'COMMON.LAST_NAME' | translate }}</label>
              <input id="last_name" type="text" class="form-control" formControlName="last_name" role="textbox" />
              <div *ngIf="submitted && form.last_name.errors" class="invalid-feedback">
                <div *ngIf="form.last_name.errors.required" role="alert" tabindex="0">
                  Last name is required
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="have_email">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span>
                Do you have an email address?
              </label>
              <select id="have_email" formControlName="have_email" [value]="-1" class="form-select"
                (change)="onHaveEmailChange()" attr.aria-label="Do you have an email address?">
                <option></option>
                <option>Yes</option>
                <option>No</option>
              </select>
              <div *ngIf="submitted && form['have_email'].errors" class="invalid-feedback">
                <div *ngIf="form['have_email'].errors.required" role="alert">
                  Answer is required
                </div>
                <div *ngIf="form['have_email'].errors.pattern" role="alert">
                  invalid answer
                </div>
              </div>
            </div>
            <span *ngIf="visibleContactQuestions === 'email'">
              <div class="form-group">
                <label for="email">
                  <span aria-hidden="true" class="form-field-required-marker">
                    *</span>
                  {{ 'COMMON.EMAIL_ADDRESS' | translate }}</label>
                <input id="email" type="email" class="form-control" formControlName="email_address" role="textbox"
                  (change)="checkIfDupeUser()" />
                <div *ngIf="submitted && form.email_address.errors" class="invalid-feedback">
                  <div *ngIf="form.email_address.errors.pattern" role="alert" tabindex="0">
                    {{ 'COMMON.VALID_EMAIL' | translate }}
                  </div>
                  <div *ngIf="form.email_address.errors.required" role="alert" tabindex="0">
                    Email address is required
                  </div>
                </div>
              </div>

              <!-- Confirm email address -->
              <div class="form-group">
                <label for="confirm_email">
                  <span aria-hidden="true" class="form-field-required-marker">
                    *</span>
                  Verify email address
                </label>

                <input id="confirm_email" type="text" class="form-control" formControlName="confirm_email"
                  role="textbox" />
                <div *ngIf="submitted && form.confirm_email.errors" class="invalid-feedback">
                  <div *ngIf="form.confirm_email.errors.mismatch" role="alert">
                    {{ 'COMMON.EMAIL_MISMATCH' | translate }}
                  </div>
                  <div *ngIf="form.confirm_email.errors.required" role="alert">
                    Email address is required
                  </div>
                </div>
              </div>
            </span>
            <div class="form-group" *ngIf="visibleContactQuestions === 'phone'">
              <label for="mobile_number">
                <span aria-hidden="true" class="form-field-required-marker">
                  *</span>
                {{ 'ACCOUNT.MY_ACCOUNT.CONTACT_NUMBER_LBL' | translate }}
              </label>
              <input id="mobile_number" type="text" class="form-control" formControlName="mobile_number"
                (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
              <div *ngIf="submitted && form.mobile_number.errors" class="invalid-feedback">
                <div *ngIf="form.mobile_number.errors.required" role="alert" tabindex="0">
                  Contact number is required
                </div>
                <div *ngIf="form.mobile_number.errors.minlength || form.mobile_number.errors.maxlength" role="alert"
                  tabindex="0">
                  Please enter a valid contact number
                </div>
              </div>
            </div>

            <!-- Customer questions -->
            <div *ngFor="let question of customerQuestions">
              <div>
                <div [ngClass]="{
                    'margin-bottom': question.help_text,
                    'form-group': true
                  }" *ngIf="
                    question.visible &&
                    !question.permanentlyHidden &&
                    question.detail_type == 'text_field'
                  ">
                  <label for="{{ customerQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>

                  <input id="{{ customerQuestionId(question) }}" type="text" class="form-control"
                    formControlName="{{ question.reference }}" role="textbox" />
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{ question.name }}
                      is required
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      invlaid {{ question.name }}
                    </div>
                    <div *ngIf="form[question.reference].errors.mismatch">
                      {{ 'COMMON.EMAIL_MISMATCH' | translate }}
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="
                    question.visible &&
                    !question.permanentlyHidden &&
                    question.detail_type == 'text_area'
                  ">
                  <label for="{{ customerQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                  <textarea id="{{ customerQuestionId(question) }}" (change)="this.formatPostcode()" class="form-control"
                    formControlName="{{ question.reference }}"></textarea>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{ question.name }}
                      is required
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      invlaid {{ question.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="
                    question.visible &&
                    !question.permanentlyHidden &&
                    question.detail_type == 'number'
                  ">
                  <label for="{{ customerQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                  <input id="{{ customerQuestionId(question) }}" type="search" class="form-control"
                    formControlName="{{ question.reference }}" (keypress)="keyPressNumberField($event)"
                    maxlength="11" />
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{ question.name }}
                      is required
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      invlaid {{ question.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="
                    (question.visible &&
                      !question.permanentlyHidden &&
                      question.detail_type == 'select') ||
                    (question.visible &&
                      !question.permanentlyHidden &&
                      question.detail_type == 'select-price')
                  ">
                  <label for="{{ customerQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                  <select id="{{ customerQuestionId(question) }}" formControlName="{{ question.reference }}" [value]="-1"
                    class="form-select" (change)="onQuestionChange()">
                    <option></option>
                    <option *ngFor="let option of question.options" [value]="option.name">
                      {{ option.name }}
                    </option>
                  </select>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{ question.name }}
                      is required
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      invlaid {{ question.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="
                    question.visible &&
                    !question.permanentlyHidden &&
                    question.detail_type == 'date'
                  ">
                  <label for="{{ customerQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                  <input id="{{ customerQuestionId(question) }}" matInput formControlName="{{ question.reference }}"
                    [matDatepicker]="picker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                  <span *ngIf="question.help_text" class="help-text mb-3 pb-3" tabindex="0"
                    [innerHTML]="question.help_text">
                  </span>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{ question.name }}
                      is required
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      invlaid {{ question.name }}
                    </div>
                  </div>
                </div>

                <!-- checkbox -->
                <div class="form-group" *ngIf="
                    (question.visible &&
                      !question.permanentlyHidden &&
                      question.detail_type == 'check') ||
                    (question.visible &&
                      !question.permanentlyHidden &&
                      question.detail_type == 'check-price')
                  ">
                  <div class="bb-flex row-blocks">
                    <label id="{{ customerQuestionId(question) }}-label"><span *ngIf="question.required"
                        aria-hidden="true" class="form-field-required-marker">*</span>
                      <span *ngIf="question.price == 0">{{
                        question.name
                        }}</span>

                      <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                        {{
                        question.price / 100 | currency : 'GBP' : true
                        }}</span></label>
                  </div>
                  <div class="bb-flex row-blocks">
                    <mat-checkbox id="{{ customerQuestionId(question) }}" formControlName="{{ question.reference }}"
                      class="form-group" attr.aria-labelledby="{{ customerQuestionId(question) }}-label">
                    </mat-checkbox>

                    <span *ngIf="question.help_text" class="help-text mb-3 pb-3" tabindex="0"
                      [innerHTML]="question.help_text">
                    </span>
                  </div>
                  <div *ngIf="
                      submitted && form[question.reference].errors?.required
                    " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                  <br>
                </div>
                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
              </div>
            </div>
          </div>

          <ng-container *ngIf="addressEnabled">
            <ng-container *ngIf="myAddresses.length === 0">

              <div class="form-group">
                <label for="postcode"><span aria-hidden="true" class="form-field-required-marker">
                    *</span>
                  {{ 'COMMON.POSTCODE1' | translate }}
                  <span style="font-weight: bold; text-decoration: underline">{{
                    'COMMON.POSTCODE2' | translate
                    }}</span>{{ 'COMMON.POSTCODE3' | translate }}</label>
                <div class="row ml-0 mr-0" style="margin: 0px !important;">
                  <div class="col-sm-8" style="padding: 0% !important;">
                    <input id="postcode" (keydown.space)="$event.preventDefault()"
                      (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                      formControlName="postcode" role="textbox"
                      oninput="this.value = this.value.replace(/\s/g, '').toUpperCase();" />
                  </div>
                  <button type="button" class="btn btn-primary col-sm-4 mb-0" [disabled]="!form.postcode.value"
                    *ngIf="!this.datastoreService.permitData && !addressLookupStatusComponent.getAddressLookupUnavailable()"
                    (click)="getAddress()">
                    {{ 'COMMON.FIND_ADDRESS' | translate }}
                  </button>
                </div>
                <div class="row ml-0 mr-0" style="margin: 0px !important;">
                  <div *ngIf="addressLookupStatusComponent.getAddressLookupUnavailable()" class="mb-0">
                    <span style="font-weight: 600; color: #DC3545;">
                      Address lookup is currently unavailable. Please enter your address manually below.
                    </span>
                  </div>
                </div>
                <div *ngIf="form.postcode.errors?.addressNotFound" role="alert" tabindex="0" class="invalid-feedback">
                  {{ form.postcode.errors?.addressNotFound }}
                </div>
                <div *ngIf="form.postcode.errors?.invalidPostcode" role="alert" tabindex="0" class="invalid-feedback">
                  {{ form.postcode.errors?.invalidPostcode }}
                </div>
                <div *ngIf="submitted && form.postcode.errors" class="invalid-feedback">
                  <div *ngIf="form.postcode.errors?.pattern" role="alert" tabindex="0" class="invalid-feedback">
                    Invalid postcode
                  </div>
                  <div *ngIf="form.postcode.errors.required" role="alert" tabindex="0">
                    Postcode is required
                  </div>
                  <div *ngIf="form.postcode.errors?.pattern" role="alert" tabindex="0" class="invalid-feedback">
                    Invalid postcode
                  </div>
                  <div *ngIf="submitted && form.selectedAddress.errors" class="invalid-feedback">
                    <div *ngIf="
                      form.selectedAddress.errors.required && !showingAddresses
                    " role="alert" tabindex="0">
                      Please click 'FIND ADDRESS'
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <span *ngIf="addresses.length > 0">
                  <label for="selectedAddress"><span aria-hidden="true" class="form-field-required-marker">
                      *</span>
                    {{ 'COMMON.ADDRESS' | translate }}</label>
                  <select id="selectedAddress" formControlName="selectedAddress" class="form-select">
                    <option value="">Please select</option>
                    <option *ngFor="let item of addresses" [ngValue]="item">
                      {{ item?.address.ADDRESS }}
                    </option>
                  </select>
                </span>
                <span *ngIf="this.datastoreService.permitData">
                  <select id="permit-address" class="form-select" disabled aria-label="Selected address">
                    <option [ngValue]="this.datastoreService.permitData.address.address.ADDRESS" selected="selected">
                      {{ this.datastoreService.permitData.address.address.ADDRESS }}
                    </option>
                  </select>
                </span>
                <div *ngIf="
                  submitted &&
                  form.selectedAddress.errors &&
                  !form.postcode.errors
                " class="invalid-feedback">
                  <div *ngIf="form.selectedAddress.errors.required" role="alert" tabindex="0">
                    An address is required
                  </div>
                </div>
                <div *ngIf="showingAddresses && !isInLocalArea">
                  <span style="font-weight: 600; color: #DC3545;"
                    [innerHTML]="this.datastoreService.config.userJourneyMessaging.outOfCountyMessage">
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="myAddresses.length > 0">
              <div class="form-group">
                <label for="selectedAddress"><span aria-hidden="true" class="form-field-required-marker">
                    * </span>Select the address where the waste is coming from.</label>
                <select formControlName="selectedAddress" [value]='-1' class="form-select" (change)="getPostcode()"
                  id="selectedAddress">

                  <option></option>
                  <option *ngFor="let option of myAddresses" [value]="option.address">
                    {{option.address}}
                  </option>

                </select>
                <div *ngIf="submitted && form.selectedAddress.errors" class="invalid-feedback">
                  <div *ngIf="form.selectedAddress.errors.required" role="alert" tabindex="0">
                    An address is required</div>
                </div>
                <div *ngIf="this.customerDetailsForm.value.selectedAddress && !isInLocalArea">
                  <span style="font-weight: 600; color: #DC3545;"
                    [innerHTML]="this.datastoreService.config.userJourneyMessaging.outOfCountyMessage">
                  </span>
                </div>
                <span class="help-text mb-3" tabindex="0">
                  If the address is not displayed, please go to 'My account' at the top of the page
                  where you can add/remove addresses.
                </span>
              </div>
            </ng-container>
            <div *ngIf="addressLookupStatusComponent.getAddressLookupUnavailable() && myAddresses.length === 0"
              class="mt-2">
              <label for="selectedAddress">
                <span aria-hidden="true" class="form-field-required-marker">*</span>
                Address where the waste is coming from.
              </label>
              <input type="text" class="form-control" id="selectedAddress" formControlName="selectedAddress" />
            </div>
          </ng-container>
        </form>
      </div>

      <div class="card mt-4 bb-panel">
        <form [formGroup]="bookingQuestionsForm" autocomplete="off" class="col-sm-12 col-md-12 col-lg-12"
          [class.submitted]="submitted">
          <h2 class="mt-1 pb-4">
            {{ 'COMMON.BOOKING_INFORMATION' | translate }}
          </h2>
          <div *ngFor="let question of bookingQuestions">
            <span *ngIf="question.id.toString() !== permitQuestion">
              <div *ngIf="
                  question.visible &&
                  !question.permanentlyHidden &&
                  question.detail_type == 'heading'
                ">
                <p>
                  <b *ngIf="question.id == 453 || question.id == 499">{{
                    question.name
                    }}</b>
                  <b *ngIf="question.id != 453 && question.id != 499">{{
                    question.name
                    }}</b>
                </p>
                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
              </div>

              <div class="form-group" *ngIf="
                  question.visible &&
                  !question.permanentlyHidden &&
                  question.detail_type == 'text_field'
                ">
                <ng-container *ngIf="!(question.name === 'Vehicle registration' && this.myVehicles.length > 0)">
                  <label for="{{ bookingQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                      class="form-field-required-marker">
                      *</span>
                    {{ question.name }}</label>
                </ng-container>
                <ng-container *ngIf="
                    question.name === 'Vehicle make' ||
                    question.name === 'Vehicle colour'
                  ">
                  <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                  <!-- No static 'disabled': the form control is disabled when the DVLA lookup is
                       available and enabled for manual entry when the lookup is unavailable. -->
                  <input id="{{ bookingQuestionId(question) }}" maxlength="20" type="text" class="form-control mb-3"
                    formControlName="{{ question.reference }}"
                    oninput="this.value = this.value.toUpperCase()" />

                </ng-container>

                <ng-container *ngIf="
                    (question.name === 'Vehicle make' ||
                      question.name === 'Vehicle colour' ||
                      question.name === 'Vehicle registration') === false
                  ">
                  <!-- 'Registration number' reference == 4 (Might need changing when merged in if id changes) -->
                  <input id="{{ bookingQuestionId(question) }}" *ngIf="question.reference != 4" type="text" class="form-control mb-3"
                    formControlName="{{ question.reference }}"
                    oninput="this.value = this.value.toUpperCase()" />
                  <input id="{{ bookingQuestionId(question) }}" *ngIf="question.reference === 4" type="text" class="form-control mb-3"
                    formControlName="{{ question.reference }}"
                    oninput="this.value = this.value.toUpperCase()" />
                </ng-container>
                <ng-container *ngIf="question.name === 'Vehicle registration'">
                  <ng-container *ngIf="this.myVehicles.length === 0">

                    <div>
                      <!-- DVLA lookup unavailable: prompt the user to enter make/colour manually -->
                      <div *ngIf="dvlaLookupUnavailable" class="mb-0">
                        <span style="font-weight: 600; color: #DC3545;">
                          Vehicle lookup is currently unavailable. Please enter your vehicle details manually below.
                        </span>
                      </div>
                      <div class="row ml-0 mr-0" style="margin: 0px !important;">
                        <div class="col-sm-8" style="padding: 0% !important;">
                          <input id="{{ bookingQuestionId(question) }}" (keydown.space)="$event.preventDefault()"
                            (keydown.spacebar)="$event.preventDefault()" type="text" class="form-control"
                            (change)="vehicleStatus = 0; motStatusInvalid = false; taxStatusInvalid = false"
                            formControlName="{{ question.reference }}" role="textbox"
                            oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()" />
                        </div>
                        <button type="button"
                          class="btn btn-primary col-sm-4 mb-0 govuk-button button-sizer search-button"
                          *ngIf="!dvlaLookupUnavailable" [disabled]="!bookingForm[question.reference].valid"
                          (click)="getVehicle()">
                          Find vehicle
                        </button>
                      </div>

                      <span *ngIf="vehicleStatus == 1" style="color: green; font-weight: 600">
                        Vehicle details confirmed by DVLA, please proceed.
                      </span>

                      <span *ngIf="vehicleStatus == 2" style="color: red; font-weight: 600">
                        Vehicle details not confirmed by DVLA, please try again, or contact the Waste Team for help on
                        0345 60 80 194
                      </span>

                      <span *ngIf="vehicleStatus == 3" style="color: red; font-weight: 600">
                        Vehicle details not confirmed by DVLA, please try again, or contact the Waste Team for help on
                        0345 60 80 194
                      </span>

                         <div *ngIf="motStatusInvalid" style="color: red; font-weight: 600;">
                      The vehicle entered does not have a valid MOT. You cannot proceed with this
                      vehicle.
                    </div>

                    <div *ngIf="taxStatusInvalid" style="color: red; font-weight: 600;">
                      The vehicle entered is not taxed. You cannot proceed with this vehicle.
                    </div>

                      <div *ngIf="registrationUsed" style="color: red; font-weight: 600">
                        The vehicle registration entered has a valid permit. Please go back to book via the ‘Van or
                        pickup’ service.
                        <br>
                        <button type="button" class="btn btn-primary" (click)="routerGoBackToServices()" title="Back"
                          aria-label="Back to services">
                          Go back to services
                        </button>
                        <br>
                        <br>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="this.myVehicles.length > 0">
                    <div class="form-group">
                      <label for="{{ bookingQuestionId(question) }}"><span *ngIf="question.required"
                          aria-hidden="true" class="form-field-required-marker">
                          * </span>Select your vehicle for this visit.</label>
                      <select id="{{ bookingQuestionId(question) }}" formControlName="{{question.reference}}"
                        [value]='-1' class="form-select" (change)="populateStoredVehicleDetails()">

                        <option></option>
                        <option *ngFor="let option of myVehicles" [value]="option.vehicle_registration">
                          {{option.vehicle_registration}}
                        </option>
                      </select>
                      <span class="help-text mb-3" tabindex="0">
                        If the vehicle is not displayed, please go to 'My account' at the top of the
                        page where you can add/remove vehicles.
                      </span>
                    </div>
                  </ng-container>
                  <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                    {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                  </div>
                  <ng-container *ngIf="!(question.name === 'Vehicle registration' && this.myVehicles.length > 0)">

                    <span *ngIf="
                    question.help_text && question.name !== 'Vehicle colour'
                  " class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                    </span>
                  </ng-container>
                  <span *ngIf="
                    question.help_text && question.name === 'Vehicle colour'
                  " class="help-text mb-3" tabindex="0" [innerHTML]="
                    'Please only note the nearest base colour, e.g. silver'
                  ">
                  </span>
                </ng-container>

              </div>

              <div *ngIf="
                  question.visible &&
                  !question.permanentlyHidden &&
                  question.detail_type == 'text_area'
                ">
                <label for="{{ bookingQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                    class="form-field-required-marker">
                    *</span>
                  {{ question.name }}</label>
                <textarea id="{{ bookingQuestionId(question) }}" class="form-control" formControlName="{{ question.reference }}"></textarea>

                <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                  {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                </div>

                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
              </div>

              <div *ngIf="
                  question.visible &&
                  !question.permanentlyHidden &&
                  question.detail_type == 'number'
                ">
                <label for="{{ bookingQuestionId(question) }}"><span *ngIf="question.required" aria-hidden="true"
                    class="form-field-required-marker">
                    *</span>
                  {{ question.name }}</label>
                <input id="{{ bookingQuestionId(question) }}" type="search" class="form-control"
                  formControlName="{{ question.reference }}"
                  maxlength="11" (keypress)="keyPressNumberField($event)" />

                <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                  {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                </div>

                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
              </div>

              <!-- select dropdown-->
              <div *ngIf="
                  question.visible &&
                  !question.permanentlyHidden &&
                  question.detail_type == 'select'
                " class="form-group">
                <label for="{{ bookingQuestionId(question) }}"><span aria-hidden="true" class="form-field-required-marker"
                    *ngIf="question.required">
                    *</span>
                  {{ question.name }}</label>
                <select id="{{ bookingQuestionId(question) }}" formControlName="{{ question.reference }}" [value]="-1"
                  class="form-select" (change)="onQuestionChange()">
                  <option></option>
                  <option *ngFor="let option of question.options" [value]="option.name">
                    {{ option.name }}
                  </option>
                </select>

                <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                  {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                </div>

                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
              </div>

              <!-- checkbox -->
              <div style="margin-bottom: 0px !important" class="form-group" *ngIf="
                  (question.visible &&
                    !question.permanentlyHidden &&
                    question.detail_type == 'check') ||
                  (question.visible &&
                    !question.permanentlyHidden &&
                    question.detail_type == 'check-price')
                ">
                <div class="bb-flex row-blocks">
                  <label id="{{ bookingQuestionId(question) }}-label" style="line-height: 0.8"><span
                      *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                      *
                    </span>
                    <span *ngIf="
                        question.price == 0 &&
                        question.reference != 438 &&
                        question.id != 452 &&
                        question.id != 498
                      ">{{ question.name }}</span>
                    <span *ngIf="
                        question.price == 0 &&
                        (question.id == 452 || question.id == 498)
                      "><b>{{ question.name }}</b></span>
                    <span *ngIf="question.price == 0 && question.reference === 438">
                      <span [innerHTML]="declaration_question_override"></span>
                    </span>
                  </label>
                </div>
                <div class="bb-flex row-blocks" style="width: 100% !important;">
                  <mat-checkbox id="{{ bookingQuestionId(question) }}" formControlName="{{ question.reference }}"
                    attr.aria-labelledby="{{ bookingQuestionId(question) }}-label" (change)="onQuestionChange()">
                    <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                      {{ question.price / 100 | currency : 'GBP' : true }}</span>
                  </mat-checkbox>
                </div>

                <div *ngIf="submitted && bookingForm[question.reference].errors" role="alert" tabindex="0"
                  class="invalid-feedback">
                  {{ 'COMMON.AGREE' | translate }}
                </div>

                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br>
              </div>

              <!-- radio -->
              <div class="row-blocks" *ngIf="
                  question.visible &&
                  !question.permanentlyHidden &&
                  question.detail_type == 'radio'
                ">
                <label id="{{ bookingQuestionId(question) }}-label">
                  <span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">*
                  </span>
                  {{ question.name }}</label>

                <mat-radio-group id="{{ bookingQuestionId(question) }}" formControlName="{{ question.reference }}"
                  attr.aria-labelledby="{{ bookingQuestionId(question) }}-label" class="col-sm-7 radio-group"
                  (change)="onQuestionChange()">
                  <mat-radio-button class="radio-button" *ngFor="let option of question.options" [value]="option.name">
                    {{ option.name }}
                  </mat-radio-button>
                </mat-radio-group>

                <div *ngIf="
                    submitted &&
                    bookingForm[question.reference].errors?.required
                  " role="alert" tabindex="0" class="invalid-feedback">
                  {{ question.name }} {{ 'COMMON.IS_REQUIRED' | translate }}
                </div>
                <span *ngIf="question.help_text" class="help-text mb-3" tabindex="0" [innerHTML]="question.help_text">
                </span>
                <br *ngIf="question.help_text" />
              </div>
              <!-- br instead of changing css -->
            </span>
          </div>
        </form>
      </div>
    </div>

    <div class="col-sm-12 col-md-5 col-lg-4 mt-4">
      <app-booking-summary></app-booking-summary>
    </div>
  </div>

  <div class="col-sm-12 col-md-7 col-lg-8">
    <div class="card mt-4 bb-panel">
      <form [formGroup]="customerDetailsForm" autocomplete="off" class="col-sm-12" [class.submitted]="submitted">
        <h2 class="mt-1 pb-4">{{ 'COMMON.DATA_POLICY' | translate }}</h2>
        <div class="bb-flex row row-blocks" id="tcs">
          <div class="bb-flex col col-blocks wide">
            <div id="PNPolicy" [innerHTML]="dataPolicy"></div>
          </div>
        </div>
        <div class="bb-flex row row-blocks mb-3" id="tcs">
          <div class="bb-flex col col-blocks bottom">
            <mat-checkbox id="PNCheck" class="checkbox mr-2 ml-2 col-sm-12 privacy-policy" validationForm="PNCheck"
              formControlName="privacy_notice" aria-describedby="PNPolicy">
              <span class="by-tick-side">By checking this box, you confirm that you have read and understood our privacy
                notice</span>
            </mat-checkbox>
          </div>
        </div>
        <div *ngIf="submitted && form.privacy_notice.errors" class="invalid-feedback">
          <div *ngIf="form.privacy_notice.errors.required" role="alert" tabindex="0">
            Please ensure that you have read and understood our data policy
            and terms of use before proceeding with your booking.
          </div>
        </div>
        <div class="bb-flex row row-blocks" id="tcs">
          <div class="bb-flex col col-blocks wide">
            <div id="TCPolicy" [innerHTML]="dataPolicyTwo"></div>
          </div>
        </div>
        <div class="bb-flex row row-blocks" id="tcs">
          <div class="bb-flex col col-blocks bottom">
            <mat-checkbox id="TCCheck" class="checkbox mr-2 ml-2 col-sm-12 privacy-policy" validationForm="TCCheck"
              formControlName="terms_and_conditions" aria-describedby="TCPolicy">
              <span class="by-tick-side">By checking this box, you confirm that you have read and understood our terms
                and conditions</span>
            </mat-checkbox>
          </div>
        </div>
        <div *ngIf="submitted && form.terms_and_conditions.errors" class="invalid-feedback">
          <div *ngIf="form.terms_and_conditions.errors.required" role="alert" tabindex="0">
            Please ensure that you have read and understood the terms and
            conditions and terms of use before proceeding with your booking.
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <button type="button" class="btn btn-primary" (click)="routerGoBack()" title="Back" aria-label="Back to calendar">
        <span>
          <fa-icon [icon]="faChevronLeft"></fa-icon><span>{{ 'COMMON.BACK' | translate }}</span>
        </span>
      </button>
    </div>
    <div class="col-6">
      <button class="btn btn-primary float-right" type="button" title="Next" aria-label="Next to summary"
        [disabled]="subtmitButtonDisabled" (click)="onSubmit()">
        <span><span>{{ 'COMMON.NEXT' | translate }}</span>
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </span>
      </button>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <button type="button" class="back-to-top" (click)="scrollToTopOfPage()">
        <fa-icon [icon]="faChevronUp" aria-hidden="true"></fa-icon>
        <span>Back to top</span>
      </button>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>

  <!-- <div>
        <span>I agree to the details submitted being processed by the re3 partnership for the purpose of managing this
            booking. Please refer to the available re3 <a target="_blank"
                href="https://www.reading.gov.uk/dataprotection"><b>Privacy Notice</b></a>.</span>
        <br><br>
        <span>I confirm that this booking is made for, or on behalf of, a resident of the re3 area and that <b>I
                understand that valid proof of address will be required upon arriving at the recycling
                centre</b>.</span>
    </div> -->
  <br />
  <br />
</div>